import styled from "styled-components";
import { Button, Container, Title } from "../../../common/styles";
import { theme } from "../../../theme";
import { ReactComponent as LoadingElement } from "./img/loading.svg";

export const StyledContainer = styled(Container)`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0 20px;
`;

export const ContactSection = styled.address`
    display: grid;
    grid-template-columns: repeat(4, auto);
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 40px;
    width: 100%;
    gap: 30px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        grid-template-columns: repeat(2, auto);
        gap: 25px;
        margin-bottom: 20px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
        gap: 10px;
        margin-bottom: 20px;
    }
`;

export const ContactBlock = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 260px;
    background-color: ${theme.colors.colorfulBackground + "88"};
    color: ${theme.colors.text};
    padding: 30px 0 15px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        min-width: 300px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        width: 100%;
        padding: 20px 0;
        min-width: 0;
    }
`;

export const ImgLinkBlock = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border-radius: 50%;
    color: ${theme.colors.red};
    background-color: ${theme.colors.white};
    cursor: pointer;
    transition: 300ms;
    &:hover{
        color: ${theme.colors.white};
        background-color: ${theme.colors.red};
    }
`;

export const ContactTitle = styled.h3`
    margin: 10px 0 10px;
    font-weight: ${theme.fonts.weights.superBold};
`;

export const ContactSubTitle = styled.span`
    margin-bottom: 30px;
    @media (max-width: ${theme.breakpoints.mobile}) {
        margin-bottom: 8px;
    }
`;

export const MiniButtonLink = styled.a`
    font-weight: ${theme.fonts.weights.bold};
    background-color: ${theme.colors.colorfulBackground};
    color: ${theme.colors.white};
    border-radius: 18px;
    padding: 8px 12px;
    cursor: pointer;
    &:hover{
        background-color: ${theme.colors.red};
    }
    &:active{
        border: 3px inset white;
        padding: 5px 9px;
    }
`;

export const StyledTitle = styled(Title)`
    align-self: center;
    margin-bottom: 0;
`;

export const Form = styled.form`
    display: grid;
    width: 100%;
    max-width: 1130px;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 30px;
    @media (max-width: ${theme.breakpoints.tablet}) {
        max-width: 625px;
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        grid-template-columns: 1fr;
        gap: 10px;
        max-width: none;
    }
`;

export const WarningText = styled.span`
    text-align: center;
    color: ${theme.colors.text};
    font-size: 23px;
    min-height: 10px;
    margin: 5px 0 5px;
    padding: 10px 0;
    font-weight: ${theme.fonts.weights.bold};
`;

export const Input = styled.input`
    background-color: ${theme.colors.colorfulBackground + "88"};
    font-weight: ${theme.fonts.weights.superBold};
    color: ${theme.colors.text};
    padding: 20px 30px;
    border: none;
    &::placeholder{
        color: ${theme.colors.text + "a"};
        font-weight: ${theme.fonts.weights.medium};
    }
`;

export const TextArea = styled.textarea`
    resize: none;
    padding: 20px 30px;
    border: none;
    height: 150px;
    color: ${theme.colors.text};
    font-weight: ${theme.fonts.weights.superBold};
    background-color: ${theme.colors.colorfulBackground + "88"};
    grid-column-start: span 2;
    &::placeholder{
        color: ${theme.colors.text + "a"};
        font-weight: ${theme.fonts.weights.medium};
    }
    @media (max-width: ${theme.breakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        grid-column-start: 1
    }
`;

export const StyledButton = styled(Button)`
    background-color: ${theme.colors.red};
    max-width: 50%;
    &:hover{
        color: ${theme.colors.colorfulBackground};
    }
    &:disabled{
        cursor: not-allowed;
        filter: opacity(20%);
        &:hover{
            transform: translateY(0);
            background-color: ${theme.colors.red};
        }
        &:active{
            background-color: ${theme.colors.red};
        }
    }
`;

export const StyledLoadingElement = styled(LoadingElement)`
    margin: 10px 0;
    color:${theme.colors.red};
    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    };
    animation: spin 1s linear infinite;
`;